import { render, staticRenderFns } from "./calcStandard.vue?vue&type=template&id=e1d859d4"
import script from "./calcStandard.vue?vue&type=script&lang=js"
export * from "./calcStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1d859d4')) {
      api.createRecord('e1d859d4', component.options)
    } else {
      api.reload('e1d859d4', component.options)
    }
    module.hot.accept("./calcStandard.vue?vue&type=template&id=e1d859d4", function () {
      api.rerender('e1d859d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/baseinfo/calcStandard.vue"
export default component.exports